module.exports = __webpack_public_path__ + "img/60.fa588075.svg";